import { createGlobalStyle } from 'styled-components'
import { commonCSS } from './commonCSS'
import { defaultDarkVars } from './defaultDarkVars'
import { wsbVars } from './wsbVars'
import { SKINS } from 'constants/skins'

import { config } from 'config/index'
import { toggleInputCSS } from 'themes/css/toggleInputCSS'

const { APP_SKIN_VERSION } = config

const themeSelector = () =>
  ({
    [SKINS.WSB]: wsbVars,
  }[APP_SKIN_VERSION])

export const GlobalStyle = createGlobalStyle`
 ${defaultDarkVars}
 ${themeSelector()}
 ${commonCSS}
 ${toggleInputCSS}
`
